var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button submit-button",class:{
    '-loading': _vm.isLoading,
    '-primary': _vm.isPrimary,
    small: _vm.isSmall,
  },attrs:{"type":"submit"},on:{"click":_vm.onClick}},[_c('moon-loader',{staticClass:"_state-spinner",attrs:{"color":'#fefefe',"size":_vm.spinnerSize}}),_c('span',{staticClass:"_button-text"},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }